// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_array from "melange.js/caml_array.js";
import * as Caml_int64 from "melange.js/caml_int64.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as CamlinternalLazy from "melange/camlinternalLazy.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "./deserialize_json.js";
import * as Ocaml_protoc_plugin__Json from "./json.js";
import * as Ocaml_protoc_plugin__Json_options from "./json_options.js";
import * as Ocaml_protoc_plugin__Ptime from "./ptime.js";
import * as Ocaml_protoc_plugin__Result from "./result.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__ArrayLabels from "melange/arrayLabels.js";
import * as Stdlib__BytesLabels from "melange/bytesLabels.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__Int32 from "melange/int32.js";
import * as Stdlib__Int64 from "melange/int64.js";
import * as Stdlib__Lazy from "melange/lazy.js";
import * as Stdlib__ListLabels from "melange/listLabels.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__Printf from "melange/printf.js";
import * as Stdlib__StringLabels from "melange/stringLabels.js";

function value_error(type_name, json) {
  return Ocaml_protoc_plugin__Result.raise({
              NAME: "Wrong_field_type",
              VAL: [
                type_name,
                Ocaml_protoc_plugin__Json.to_string(json)
              ]
            });
}

function int32_value(v) {
  return {
          NAME: "Int",
          VAL: v
        };
}

function int32_int_value(v) {
  return {
          NAME: "Int",
          VAL: v
        };
}

function int64_value(v) {
  return {
          NAME: "String",
          VAL: Stdlib__Int64.to_string(v)
        };
}

function int64_int_value(v) {
  return {
          NAME: "String",
          VAL: String(v)
        };
}

function bool_value(v) {
  return {
          NAME: "Bool",
          VAL: v
        };
}

function string_value(v) {
  return {
          NAME: "String",
          VAL: v
        };
}

function bytes_value(v) {
  return {
          NAME: "String",
          VAL: Stdlib__BytesLabels.unsafe_to_string(v)
        };
}

function float_value(v) {
  if (Stdlib__Float.is_integer(v)) {
    return {
            NAME: "Int",
            VAL: v | 0
          };
  } else {
    return {
            NAME: "Float",
            VAL: v
          };
  }
}

function key_to_string(json) {
  if (typeof json !== "string") {
    const variant = json.NAME;
    if (variant === "String") {
      return json.VAL;
    }
    if (variant === "Int") {
      return String(json.VAL);
    }
    if (variant === "Bool") {
      return Stdlib.string_of_bool(json.VAL);
    }
    
  }
  return Ocaml_protoc_plugin__Result.raise({
              NAME: "Wrong_field_type",
              VAL: [
                "map key",
                Ocaml_protoc_plugin__Json.to_string(json)
              ]
            });
}

function key(json_names, param) {
  if (json_names) {
    return param[2];
  } else {
    return param[1];
  }
}

function get_key(f, $$default, key, json) {
  if (typeof json === "string" || json.NAME !== "Assoc") {
    return value_error("Expected Assoc", json);
  } else {
    return Stdlib__Option.value(Stdlib__Option.map(f, Stdlib__ListLabels.assoc_opt(key, json.VAL)), $$default);
  }
}

function duration_to_json(json) {
  const seconds = get_key(Ocaml_protoc_plugin__Deserialize_json.to_int64, Caml_int64.zero, "seconds", json);
  const nanos = get_key(Ocaml_protoc_plugin__Deserialize_json.to_int32, 0, "nanos", json);
  const seconds$1 = Caml.i64_lt(seconds, Caml_int64.zero) || nanos < 0 ? Caml_int64.mul(Caml_int64.neg_one, Stdlib__Int64.abs(seconds)) : Stdlib__Int64.abs(seconds);
  const duration = nanos !== 0 ? Curry._2(Stdlib__Printf.sprintf(/* Format */{
              _0: {
                TAG: /* Int64 */7,
                _0: /* Int_d */0,
                _1: /* No_padding */0,
                _2: /* No_precision */0,
                _3: {
                  TAG: /* Char_literal */12,
                  _0: /* '.' */46,
                  _1: {
                    TAG: /* Int32 */5,
                    _0: /* Int_d */0,
                    _1: {
                      TAG: /* Lit_padding */0,
                      _0: /* Zeros */2,
                      _1: 9
                    },
                    _2: /* No_precision */0,
                    _3: {
                      TAG: /* Char_literal */12,
                      _0: /* 's' */115,
                      _1: /* End_of_format */0
                    }
                  }
                }
              },
              _1: "%Ld.%09lds"
            }), seconds$1, Stdlib__Int32.abs(nanos)) : Curry._1(Stdlib__Printf.sprintf(/* Format */{
              _0: {
                TAG: /* Int64 */7,
                _0: /* Int_d */0,
                _1: /* No_padding */0,
                _2: /* No_precision */0,
                _3: {
                  TAG: /* Char_literal */12,
                  _0: /* 's' */115,
                  _1: /* End_of_format */0
                }
              },
              _1: "%Lds"
            }), seconds$1);
  return {
          NAME: "String",
          VAL: duration
        };
}

function timestamp_to_json(json) {
  const seconds = get_key(Ocaml_protoc_plugin__Deserialize_json.to_int64, Caml_int64.zero, "seconds", json);
  const nanos = get_key(Ocaml_protoc_plugin__Deserialize_json.to_int64, Caml_int64.zero, "nanos", json);
  const s1 = Stdlib__Option.get(Ocaml_protoc_plugin__Ptime.Span.of_float_s(Caml_int64.to_float(seconds)));
  const s2 = Stdlib__Option.get(Ocaml_protoc_plugin__Ptime.Span.of_float_s(Caml_int64.to_float(nanos) / 1000000000.0));
  const t = Stdlib__Option.get(Ocaml_protoc_plugin__Ptime.of_span(Ocaml_protoc_plugin__Ptime.Span.add(s1, s2)));
  const s = Stdlib__StringLabels.concat("-", Stdlib__ListLabels.rev(Stdlib__ListLabels.tl(Stdlib__ListLabels.rev(Stdlib__StringLabels.split_on_char(/* '-' */45, Ocaml_protoc_plugin__Ptime.to_rfc3339(undefined, 9, undefined, t))))));
  return {
          NAME: "String",
          VAL: s + "Z"
        };
}

function wrapper_to_json(json) {
  return get_key((function (id) {
                return id;
              }), "Null", "value", json);
}

function map_enum_json(Enum) {
  const name = Stdlib__StringLabels.concat(".", Stdlib__ListLabels.tl(Stdlib__StringLabels.split_on_char(/* '.' */46, Curry._1(Enum.name, undefined))));
  if (name === "google.protobuf.NullValue") {
    return function (json) {
      if (typeof json === "string") {
        return value_error(name, json);
      }
      const variant = json.NAME;
      if (variant === "String") {
        if (json.VAL === Curry._1(Enum.to_string, Curry._1(Enum.from_int_exn, 0))) {
          return "Null";
        } else {
          return value_error(name, json);
        }
      } else if (variant === "Int" && json.VAL === 0) {
        return "Null";
      } else {
        return value_error(name, json);
      }
    };
  } else {
    return function (json) {
      return json;
    };
  }
}

function map_message_json(name) {
  switch (name) {
    case ".google.protobuf.Duration" :
        return duration_to_json;
    case ".google.protobuf.Empty" :
        return (function (json) {
                  return json;
                });
    case ".google.protobuf.FieldMask" :
        return (function (json) {
                  if (typeof json === "string") {
                    return value_error(name, json);
                  }
                  if (json.NAME !== "Assoc") {
                    return value_error(name, json);
                  }
                  const match = json.VAL;
                  if (!match) {
                    return value_error(name, json);
                  }
                  const match$1 = match.hd;
                  if (match$1[0] !== "paths") {
                    return value_error(name, json);
                  }
                  const match$2 = match$1[1];
                  if (typeof match$2 === "string" || !(match$2.NAME === "List" && !match.tl)) {
                    return value_error(name, json);
                  } else {
                    return {
                            NAME: "String",
                            VAL: Stdlib__StringLabels.concat(",", Stdlib__ListLabels.map((function (json) {
                                        if (typeof json === "string" || json.NAME !== "String") {
                                          return value_error(name, json);
                                        } else {
                                          let s = json.VAL;
                                          return Stdlib__StringLabels.uncapitalize_ascii(Stdlib__StringLabels.concat("", Stdlib__ListLabels.map(Stdlib__StringLabels.capitalize_ascii, Stdlib__ListLabels.map(Stdlib__StringLabels.lowercase_ascii, Stdlib__StringLabels.split_on_char(/* '_' */95, s)))));
                                        }
                                      }), match$2.VAL))
                          };
                  }
                });
    case ".google.protobuf.ListValue" :
        return (function (json) {
                  if (typeof json === "string") {
                    return value_error(name, json);
                  }
                  if (json.NAME !== "Assoc") {
                    return value_error(name, json);
                  }
                  const match = json.VAL;
                  if (!match) {
                    return value_error(name, json);
                  }
                  const match$1 = match.hd;
                  if (match$1[0] === "values" && !match.tl) {
                    return match$1[1];
                  } else {
                    return value_error(name, json);
                  }
                });
    case ".google.protobuf.Struct" :
        return (function (json) {
                  if (typeof json === "string") {
                    return value_error(name, json);
                  }
                  if (json.NAME !== "Assoc") {
                    return value_error(name, json);
                  }
                  const match = json.VAL;
                  if (!match) {
                    return value_error(name, json);
                  }
                  const match$1 = match.hd;
                  if (match$1[0] === "fields" && !match.tl) {
                    return match$1[1];
                  } else {
                    return value_error(name, json);
                  }
                });
    case ".google.protobuf.Timestamp" :
        return timestamp_to_json;
    case ".google.protobuf.BoolValue" :
    case ".google.protobuf.BytesValue" :
    case ".google.protobuf.DoubleValue" :
    case ".google.protobuf.FloatValue" :
    case ".google.protobuf.Int32Value" :
    case ".google.protobuf.Int64Value" :
    case ".google.protobuf.StringValue" :
    case ".google.protobuf.UInt32Value" :
    case ".google.protobuf.UInt64Value" :
        return wrapper_to_json;
    case ".google.protobuf.Value" :
        return (function (json) {
                  if (typeof json === "string") {
                    return value_error(name, json);
                  }
                  if (json.NAME !== "Assoc") {
                    return value_error(name, json);
                  }
                  const match = json.VAL;
                  if (match && !match.tl) {
                    return match.hd[1];
                  } else {
                    return value_error(name, json);
                  }
                });
    default:
      return ;
  }
}

function json_of_spec(options, Enum) {
  if (typeof Enum === "number") {
    switch (Enum) {
      case /* Double */0 :
      case /* Float */1 :
          return float_value;
      case /* Int32 */2 :
      case /* UInt32 */3 :
      case /* SInt32 */4 :
      case /* Fixed32 */5 :
      case /* SFixed32 */6 :
          return int32_value;
      case /* UInt64 */12 :
      case /* Int64 */13 :
      case /* SInt64 */14 :
      case /* Fixed64 */15 :
      case /* SFixed64 */16 :
          return int64_value;
      case /* UInt64_int */17 :
      case /* Int64_int */18 :
      case /* SInt64_int */19 :
      case /* Fixed64_int */20 :
      case /* SFixed64_int */21 :
          return int64_int_value;
      case /* Bool */22 :
          return bool_value;
      case /* String */23 :
          return string_value;
      case /* Bytes */24 :
          return bytes_value;
      default:
        return int32_int_value;
    }
  } else {
    if (Enum.TAG === /* Enum */0) {
      const Enum$1 = Enum._0;
      const map_enum_json$1 = map_enum_json(Enum$1);
      const f = options.enum_names ? (function (param) {
            return {
                    NAME: "String",
                    VAL: Curry._1(Enum$1.to_string, param)
                  };
          }) : (function (param) {
            return {
                    NAME: "Int",
                    VAL: Curry._1(Enum$1.to_int, param)
                  };
          });
      return function (v) {
        return Curry._1(map_enum_json$1, Curry._1(f, v));
      };
    }
    const Message = Enum._0;
    return function (v) {
      return Curry._2(Message.to_json, options, v);
    };
  }
}

function write(options, param) {
  switch (param.TAG | 0) {
    case /* Basic */0 :
        const $$default = param._2;
        const key$1 = key(options.json_names, param._0);
        const to_json = json_of_spec(options, param._1);
        return function (v) {
          if (options.omit_default_values && Caml_obj.caml_equal(v, $$default)) {
            return /* [] */0;
          } else {
            return {
                    hd: [
                      key$1,
                      Curry._1(to_json, v)
                    ],
                    tl: /* [] */0
                  };
          }
        };
    case /* Basic_opt */1 :
        const key$2 = key(options.json_names, param._0);
        const to_json$1 = json_of_spec(options, param._1);
        return function (v) {
          if (v !== undefined) {
            return {
                    hd: [
                      key$2,
                      Curry._1(to_json$1, Caml_option.valFromOption(v))
                    ],
                    tl: /* [] */0
                  };
          } else {
            return /* [] */0;
          }
        };
    case /* Basic_req */2 :
        const key$3 = key(options.json_names, param._0);
        const to_json$2 = json_of_spec(options, param._1);
        return function (v) {
          return {
                  hd: [
                    key$3,
                    Curry._1(to_json$2, v)
                  ],
                  tl: /* [] */0
                };
        };
    case /* Repeated */3 :
        const key$4 = key(options.json_names, param._0);
        const to_json$3 = json_of_spec(options, param._1);
        return function (v) {
          const value_1 = Stdlib__ListLabels.map(to_json$3, v);
          const value = {
            NAME: "List",
            VAL: value_1
          };
          return {
                  hd: [
                    key$4,
                    value
                  ],
                  tl: /* [] */0
                };
        };
    case /* Map */4 :
        const match = param._1;
        const value_compound = match[1];
        const key$5 = key(options.json_names, param._0);
        const json_of_key = json_of_spec({
              enum_names: options.enum_names,
              json_names: options.json_names,
              omit_default_values: false
            }, match[0]);
        let json_of_value;
        if (value_compound.TAG === /* Basic */0) {
          json_of_value = json_of_spec(options, value_compound._1);
        } else {
          const json_of_value$1 = json_of_spec(options, value_compound._1);
          json_of_value = (function (v) {
              if (v !== undefined) {
                return Curry._1(json_of_value$1, Caml_option.valFromOption(v));
              } else {
                return "Null";
              }
            });
        }
        const json_of_entry = function (param) {
          const key = key_to_string(Curry._1(json_of_key, param[0]));
          const value = Curry._1(json_of_value, param[1]);
          return [
                  key,
                  value
                ];
        };
        return function (vs) {
          if (!vs && !options.omit_default_values) {
            return /* [] */0;
          }
          return {
                  hd: [
                    key$5,
                    {
                      NAME: "Assoc",
                      VAL: Stdlib__ListLabels.map(json_of_entry, vs)
                    }
                  ],
                  tl: /* [] */0
                };
        };
    case /* Oneof */5 :
        const match$1 = param._0;
        const index_f = match$1[1];
        const array = Stdlib__ArrayLabels.of_list(Stdlib__ListLabels.map((function (param) {
                    const destr = param._2[1];
                    const to_json = json_of_spec(options, param._1);
                    const key$6 = key(options.json_names, param._0);
                    return function (v) {
                      return {
                              hd: [
                                key$6,
                                Curry._1(to_json, Curry._1(destr, v))
                              ],
                              tl: /* [] */0
                            };
                    };
                  }), match$1[0]));
        return function (v) {
          if (v === "not_set") {
            return /* [] */0;
          }
          const f = Caml_array.get(array, Curry._1(index_f, v));
          return Curry._1(f, v);
        };
    
  }
}

function serialize(message_name, options) {
  const mapping = map_message_json(message_name);
  const match = mapping !== undefined ? [
      false,
      (function (json) {
          return Curry._1(mapping, {
                      NAME: "Assoc",
                      VAL: Stdlib__ListLabels.rev(json)
                    });
        })
    ] : [
      options.omit_default_values,
      (function (json) {
          return {
                  NAME: "Assoc",
                  VAL: Stdlib__ListLabels.rev(json)
                };
        })
    ];
  const map_result = match[1];
  const options_enum_names = options.enum_names;
  const options_json_names = options.json_names;
  const options_omit_default_values = match[0];
  const options$1 = {
    enum_names: options_enum_names,
    json_names: options_json_names,
    omit_default_values: options_omit_default_values
  };
  const inner = function (_extension_ranges) {
    if (typeof _extension_ranges === "number") {
      return map_result;
    }
    if (_extension_ranges.TAG === /* Nil_ext */0) {
      return function (json, _extensions) {
        return Curry._1(map_result, json);
      };
    }
    const cont = inner(_extension_ranges._1);
    const write$1 = write(options$1, _extension_ranges._0);
    return function (acc, v) {
      const v$1 = Curry._1(write$1, v);
      return Curry._1(cont, Stdlib__ListLabels.rev_append(v$1, acc));
    };
  };
  return inner;
}

function serialize$1(message_name, spec) {
  const arr = Stdlib__ArrayLabels.init(Ocaml_protoc_plugin__Json_options.max_int + 1 | 0, (function (i) {
          return Stdlib__Lazy.from_fun(function (param) {
                      return Curry._1(serialize(message_name, Ocaml_protoc_plugin__Json_options.of_int(i))(spec), /* [] */0);
                    });
        }));
  return function (options) {
    return CamlinternalLazy.force(Caml_array.get(arr, Ocaml_protoc_plugin__Json_options.to_int(options)));
  };
}

export {
  serialize$1 as serialize,
}
/* Ocaml_protoc_plugin__Deserialize_json Not a pure module */
